module.exports = __webpack_public_path__ + "img/_Generic2.65036ab1.jpg";